import { useForm as useInternalForm } from 'react-hook-form';

const useForm = (defaultValues = {}) => useInternalForm({ defaultValues, mode: 'onBlur' });

export default useForm;
